import React, { useMemo } from "react";
import DropdownSelect from "../../../../components/DropdownSelect";
import {
  KnockOrderItemType,
  ORDER_CANCLE_STATUS,
  ORDER_WAIT_STATUS,
} from "../../../../recoil/type";
import { getOrderComment } from "../../../../utils/StatusComment";

interface OrderStatusButtonProps {
  props: KnockOrderItemType;
  deliveryStatus: number;
  isBlink: boolean;
  minute: any;
  onChange_minute: (minute: any) => void;
  onChange_status: () => void;
  isDisabledStatusButton: () => boolean;
}

const minuteList: any = [];
for (let i = 3; i < 19; i++) {
  minuteList.push({
    key: i,
    value: i * 5,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const OrderStatusButton = ({
  props,
  deliveryStatus,
  isBlink,
  minute,
  onChange_minute,
  onChange_status,
  isDisabledStatusButton,
}: OrderStatusButtonProps) => {
  const OrderStatusButton = useMemo(() => {
    return (
      <div
        className={`buttonContainer delivery
        ${isDisabledStatusButton() && "disabled"}  ${isBlink && "notCheck"} ${
          props.child.order_status === ORDER_CANCLE_STATUS && "cancel"
        }`}
      >
        <div className="buttonWrap" onClick={onChange_status}>
          <h3>{getOrderComment(props.app_name, props.child.order_status)}</h3>
          {/* {props.child.order_status === ORDER_COM_COOK_STATUS &&
            deliveryStatus === 2 && <h4>픽업 15분 남음</h4>} */}
          {props.child.order_status === ORDER_CANCLE_STATUS && (
            <h4 className="cancel">{props.child.cancel_description}</h4>
          )}
        </div>

        {props.child.order_status === ORDER_WAIT_STATUS &&
          props.app_name === "KNOCK" && (
            <div className="timeSelectBox">
              <DropdownSelect
                options={minuteList}
                defaultValue={minute}
                onChangeValue={onChange_minute}
              />
            </div>
          )}
      </div>
    );
  }, [
    isBlink,
    props.order_id,
    props.child.order_status,
    props.child.delivery_type,
    props.child.delivery_estimated_time,
    props.child.delivery_expected_at,
    deliveryStatus,
  ]);

  return OrderStatusButton;
};

export default OrderStatusButton;
